// extracted by mini-css-extract-plugin
export default {"sform":"remove-warehouse_sform__aPfBA"};